import type { NextPage } from 'next';
import { useRouter } from 'next/router';

import { MotionConfig, XumoToast, PageContent, PageMetadata } from './';
import { GeneralPageProps, ToastsProvider } from '../';
import { CookieConsentScripts } from 'ui';

export const GeneralPage: NextPage<GeneralPageProps> = ({ page, metadata, locale }) => {
  const router = useRouter();
  const slug = router.query.slug || [''];
  const path = '/' + (slug as string[]).join('/');

  return (
    <div key={'gen-page' + path} className="overflow-x-clip" suppressHydrationWarning>
      <CookieConsentScripts />
      <ToastsProvider>
        <PageMetadata {...metadata} path={path} />
        <MotionConfig>
          <main className="w-full" role="main">
            <PageContent page={page} />
          </main>
        </MotionConfig>
        <XumoToast />
      </ToastsProvider>
    </div>
  );
};
